
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/[country]/w/[symbol]",
      function () {
        return require("private-next-pages/[language]/[country]/w/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[language]/[country]/w/[symbol]"])
      });
    }
  